import { FeedbackMessengerWindow } from './feedback-messenger-window.component'
import { FeedbackMessengerWindowWysiwyg } from './wysiwyg/feedback-messenger-window-wysiwyg.component'

export const FeedbackMessenger = (() => {
	const init = () => {
		FeedbackMessengerWindow.init()
		FeedbackMessengerWindowWysiwyg.init()
	}

	return {
		init,
	}
})()
